import React, { FC } from 'react';

import UtilFunctions from '~utils/functions';
import * as Styles from './_navButton.module.scss';

export type TNavButtonSubNav = {
    label: string;
    isActive: boolean;
    onClick: () => void;
}[];

type TNavButtonProps = {
    label: string;
    isActive?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    subNav?: TNavButtonSubNav;
}

const NavButton: FC<TNavButtonProps> = ({
    label,
    onClick,
    isActive,
    subNav,
}) => {
    // if subnav is provided, disable the main button
    const disabled = subNav && subNav?.length > 0;

    const mainNavStyles = UtilFunctions.Styles.concatClassNames([
        Styles.container,
        (disabled ? Styles.disabled : ''),
        (isActive && !disabled ? Styles['is-active'] : ''), // not highlighting button if disabled
    ]);

    const subNavStyles = UtilFunctions.Styles.concatClassNames([
        Styles.container,
        Styles['sub-nav-button'],
    ]);

    const renderSubNav = () => {
        if (!subNav) return null;

        return subNav.map(item => {
            const {
                label: subNavLabel,
                onClick: subNavOnClick,
                isActive: subNavIsActive,
            } = item;

            return (
                <button
                    key={subNavLabel}
                    className={`${subNavStyles}${subNavIsActive ? ` ${Styles['is-active']}` : ''}`}
                    onClick={subNavOnClick}
                    data-testid={`sub-nav-${subNavLabel}`}
                >
                    {subNavLabel}
                </button>
            );
        });
    };

    if (disabled) {
        return (
            <div className={mainNavStyles}>
                <div className={Styles.label}>
                    {label}
                </div>

                <div className={Styles['sub-nav-container']}>
                    {renderSubNav()}
                </div>
            </div>
        );
    }

    return (
        <button
            onClick={onClick && onClick}
            className={mainNavStyles}
            data-testid={`nav-${label}`}
        >
            {label}
        </button>
    );
};

export default NavButton;
